import { useEffect, useState } from "react";
import { webUrlNode } from "../../constants/appInfo";
import { useSelector } from "react-redux";
 import { useHistory,} from "react-router-dom";
export default function AdminAllCreditRecharges() {
 const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
      const history = useHistory();
  if(!appToken){
  
  
       history.push(`/apps`);
  }

  const [rows, setRows] = useState([]);

  const [filters, setFilters] = useState({
    channel: "",
    tenantId: "",
    status: "",
    from: "",
    to: ""
  });

  const [page, setPage] = useState(0);
  const limit = 50;

  useEffect(() => {
    load();
  }, [page,filters?.channel,filters?.tenantId,filters?.status,filters?.from,filters?.to]);

  async function load() {

    const q = new URLSearchParams({
      ...Object.fromEntries(
        Object.entries(filters)
          .filter(([_, v]) => v)
      ),
      limit,
      offset: page * limit,appToken:appToken,currentToken:currentToken,
    }).toString();

    const r = await fetch(
      `${webUrlNode}/api/admin/credits/recharges?${q}`,
      
    );

    const j = await r.json();
    setRows(j.length?j : []);
  }

  function apply() {
    setPage(0);
    load();
  }
function StatusBadge({ status }) {
  const colors = {
    created: "#f59e0b",
    paid: "#10b981",
    failed: "#ef4444"
  };

  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 600,
        background: colors[status] + "20",
        color: colors[status],
        textTransform: "capitalize"
      }}
    >
      {status}
    </span>
  );
}
  return (
    <div style={styles.wrapper}>

      <h2 style={styles.heading}>All Credit Purchases</h2>

      {/* Filters */}
      <div style={styles.filterCard}>

        <input
          style={styles.input}
          placeholder="Tenant ID"
          value={filters.tenantId}
          onChange={e =>
            setFilters({ ...filters, tenantId: e.target.value })
          }
        />

        <select
          style={styles.input}
          value={filters.channel}
          onChange={e =>
            setFilters({ ...filters, channel: e.target.value })
          }
        >
          <option value="">All channels</option>
          <option value="email">Email</option>
          <option value="sms">SMS</option>
          <option value="whatsapp">WhatsApp</option>
          <option value="push">Push</option>
          <option value="ai">AI</option>
        </select>

        <select
          style={styles.input}
          value={filters.status}
          onChange={e =>
            setFilters({ ...filters, status: e.target.value })
          }
        >
          <option value="">All status</option>
          <option value="created">Created</option>
          <option value="paid">Paid</option>
          <option value="failed">Failed</option>
        </select>

        <input
          type="date"
          style={styles.input}
          value={filters.from}
          onChange={e =>
            setFilters({ ...filters, from: e.target.value })
          }
        />

        <input
          type="date"
          style={styles.input}
          value={filters.to}
          onChange={e =>
            setFilters({ ...filters, to: e.target.value })
          }
        />

        <button style={styles.applyBtn} onClick={apply}>
          Apply
        </button>

      </div>

      {/* Table */}
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Tenant</th>
              <th>Channel</th>
              <th>Pack</th>
              <th>Credits</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>

          <tbody>
            {rows?.length ? (
              rows.map(r => (
                <tr key={r.id}>
                  <td>{r.id}</td>
                  <td style={styles.mono}>{r.tenantId}</td>
                  <td style={{ textTransform: "capitalize" }}>
                    {r.channel}
                  </td>
                  <td>{r.packName || "MANUAL"}</td>
                  <td>{r.credits}</td>
                  <td style={styles.amount}>
                    ₹{(r.amountPaise / 100).toFixed(2)}
                  </td>
                  <td>
                    <StatusBadge status={r.status} />
                  </td>
                  <td>
                    {new Date(r.createdAt).toLocaleString()}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={styles.noData}>
                  No purchases found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div style={styles.pagination}>
        <button
          disabled={page === 0}
          style={styles.pageBtn}
          onClick={() => setPage(p => Math.max(0, p - 1))}
        >
          ← Prev
        </button>

        <button
          style={styles.pageBtn}
          onClick={() => setPage(p => p + 1)}
        >
          Next →
        </button>
      </div>
 <style>
        {`
        
table th {background:#f9f9f9; padding:10px}
         
table td {background:#ffffff; padding:10px}
        `} </style>
    </div>
  );
}
const styles = {
  wrapper: {
    padding: 24,
    background: "#f8fafc",
  
    fontFamily: "Inter, sans-serif"
  },

  heading: {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 20
  },

  filterCard: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    background: "#fff",
    padding: 15,
    borderRadius: 12,
    marginBottom: 20,
    boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
  },

  input: {
    padding: "8px 10px",
    borderRadius: 8,
    border: "1px solid #e5e7eb",
    minWidth: 140
  },

  applyBtn: {
    padding: "8px 14px",
    borderRadius: 8,
    border: "none",
    background: "#4f46e5",
    color: "#fff",
    cursor: "pointer",
    fontWeight: 600
  },

  tableWrapper: {
    overflowX: "auto",
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 6px 25px rgba(0,0,0,0.05)"
  },

  table: {
    width: "100%",textAlign:"center",
    borderCollapse: "collapse",
    minWidth: 1000
  },

  mono: {
    fontFamily: "monospace",
    fontSize: 13
  },

  amount: {
    fontWeight: 600
  },

  noData: {
    padding: 20,
    textAlign: "center",
    color: "#94a3b8"
  },

  pagination: {
    marginTop: 20,
    display: "flex",
    gap: 10
  },

  pageBtn: {
    padding: "8px 14px",
    borderRadius: 8,
    border: "1px solid #e5e7eb",
    background: "#fff",
    cursor: "pointer"
  }
};